import { FunctionComponent } from 'react'

import styled, { css, useTheme } from 'styled-components'

import { SvgIconName } from '@components/SvgIcon/types'

import SvgIcon from '../SvgIcon'

interface Props {
  type?: SvgIconName
}

const StyledPlayIcon = styled(SvgIcon)``

const PlayIconContainer = styled.div`
  ${({
    theme: {
      colors: { fillBrand, fillBrandHover },
      spacing: { spacing64, spacing80 },
    },
  }) => css`
    background-color: ${fillBrand};
    border-radius: ${spacing64};
    width: ${spacing80};
    height: ${spacing80};
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
      background-color: ${fillBrandHover};
    }
  `}
`

const PlayIcon: FunctionComponent<Props> = ({
  type = 'video-play-sharp-filled',
}) => {
  const theme = useTheme()

  return (
    <PlayIconContainer>
      <StyledPlayIcon
        className="play-icon"
        iconName={type}
        size={36}
        color={theme.colors.staticWhite}
      />
    </PlayIconContainer>
  )
}

export default PlayIcon
